import classNames from "classnames";
import React from "react";
import { PhosphorX } from "./PhosphorIcon";

interface Props {
  color?: "blue"
  onClear?: () => void
}

export const ClearablePill = (props: React.PropsWithChildren<Props>) => {
  return <div className={classNames("clearable-pill", props.color)}>
    <div className="clearable-pill-label">{props.children}</div>
    {props.onClear && <button type="button" className="clearable-pill-clear" onClick={props.onClear}>
      <PhosphorX iconSize="small" />
    </button>}
  </div>;
};
